var _rect, _rect2, _rect3, _path, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstFloor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 569,
    viewBox: "0 0 384 569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 569,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 380,
    height: 565,
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "f1b4",
    x: 2,
    y: 2,
    width: 198,
    height: 164,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f1b5",
    d: "M2 275 H118 V255 H200 V372 H2 Z",
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "f1k",
    x: 200,
    y: 2,
    width: 180,
    height: 99,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f1l",
    d: "M200 101 H380 V255 H246 V372 H200 V255 H118 V166 H200 Z",
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "pumproom",
    x: 2,
    y: 120,
    width: 116,
    height: 45,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "f1w",
    x: 2,
    y: 165,
    width: 116,
    height: 110,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "f1c",
    x: 244,
    y: 255,
    width: 62,
    height: 117,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "f1s",
    x: 306,
    y: 255,
    width: 74,
    height: 117,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "g",
    x: 2,
    y: 372,
    width: 378,
    height: 195,
    fill: "#d9d9d9",
    stroke: "#000",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 101,
    y: 84,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Bedroom 4")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 101,
    y: 314,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Bedroom 5")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 290,
    y: 51.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Kitchen")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 275,
    y: 180,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Living room")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 60,
    y: 220,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Washroom")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 223,
    y: 313.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000",
    transform: "rotate(-90 223 313.5)"
  }, "Hallway")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 275,
    y: 313.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000",
    transform: "rotate(-90 275 313.5)"
  }, "Storage")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 343,
    y: 313.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000",
    transform: "rotate(-90 340 313.5)"
  }, "Staircase")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 191,
    y: 469.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#000"
  }, "Garage")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstFloor);
export default __webpack_public_path__ + "static/media/first_floor.d6c051421d58eaa6007d56fef6f44838.svg";
export { ForwardRef as ReactComponent };